const Main = (props) => {
	return <main className=" w-full flex flex-col">{props.children}</main>;
};

export { Main };
